import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { GlobalsVariables } from '../global-Variables';
import { Router, ActivationEnd, ActivatedRoute } from '@angular/router';
import { LightboxConfig, Lightbox } from 'ngx-lightbox';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { stringify } from '@angular/compiler/src/util';


export interface Project {
    head?: Head;
    images?: Images[];
}
export interface Head {
    links?: {
        [key:string]:string;
    }[];
    line: string;
    image?: string;
    text?: string;
    column?: string;
    imagesInfo?: string;
    imageProperties?:{
        [key:string]:string | number;
    }
}
export interface Images {
    grid: number;
    divCon: string;
    src?: string;
    thumb?: string;
    video?: string;
    caption?: string;
    infoText?: string;
    sold?: boolean;
}


@Component({
  selector: 'app-galery',
  templateUrl: './galery.component.html',
  providers: [Location, {provide: LocationStrategy, useClass: PathLocationStrategy}],
  styleUrls: ['./galery.component.scss']
})

export class GaleryComponent implements OnInit {

    public projectArray: Project;
    public whichSub: string;
    public lightboxSource: Array<any>;

    ex = {
        benotafeard: {
            head: {
                line: 'be not afeard',
                links: [
                    {
                        link: './assets/pdf/exhibition/be-not-afeard/be-not-afeard.pdf',
                        target: '_blank',
                        text: '<span class="cBold">_ download:</span> be not afeard booklet'
                    },
                    {
                        link: ['/art-projects/benotafeard'],
                        text: '<span class="cBold">_ art&projects:</span>  be not afeard'
                    }
                ],
                image: './assets/img/exhibition/be-not-afeard/be-not-afeard-cover.jpg',
                // imagesInfo : 'sdsa dad ad adad sad d',
                // tslint:disable-next-line: max-line-length
                text: `<span class="cBold">18. November 2018 bis 16. Dezember 2018</span>
                <br/>
                _„Be Not Afeard“ im Rahmen der Art Ambulanz Pop Up Gallery in Ratingen
                <br/><br/>
                "Be Not Afeard" ("Sei ohne Furcht"), ein Zitat aus William Shakespeares "The Tempest" ("Der Sturm"), verweist auf Situationen in den Grenzbereichen persönlicher Erfahrung:
                Den Sprung ins Ungewisse; das Vertrauen darauf, aufgefangen zu werden; die Zerbrechlichkeit von Berührung; das Offenlegen des Ich.
                <br/><br/>
                Mut und Angst, Hoffnung und Verzweiflung, Ruhe und Kraft, Offenheit und Zurückhaltung, Traum und Wirklichkeit liegen hier dicht beieinander. Die Motive ermöglichen eine direkte Identifikation mit dem Gezeigten und zusätzlich die Assoziation mit dem selbst Erlebten. Sie können daher auch als Allegorie auf den Alltag des Betrachters verstanden werden.`
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-10.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-10.jpg',
                    caption: `BeNotAfeard _ Jump II (01.2018)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    33,7 x 50,3 cm`
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/exhibition/be-not-afeard/be-not-afeard-2.jpg',
                    thumb: './assets/img/exhibition/be-not-afeard/be-not-afeard-2.jpg',
                    caption: `Be-Not-Afeard _ Monk (11.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    50,3 x 33,7 cm`
                },
                {
                    grid: 5,
                    divCon: 'right',
                    src: './assets/img/exhibition/be-not-afeard/be-not-afeard-3.jpg',
                    thumb: './assets/img/exhibition/be-not-afeard/be-not-afeard-3.jpg',
                    caption: `Be-Not-Afeard _ Target (02.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    33,7 x 50,3 cm`
                }
            ]
        },
        aholyfamily: {
            head: {
                links: [
                    {
                        link: './assets/pdf/exhibition/a-holy-family/a-holy-family.pdf',
                        target: '_blank',
                        text: '<span class="cBold">_ download:</span> a holy family booklet'
                    },
                    {
                        link: ['/art-projects/aholyfamily'],
                        text: '<span class="cBold">_ art&projects:</span> a holy family'
                    }
                ],
                line: 'a holy family',
                image: './assets/img/exhibition/a-holy-family/a-holy-family-cover.jpg',
                // tslint:disable-next-line: max-line-length
                text: `<span class="cBold">29. November 2015 bis 10. Januar 2016</span>
                <br/>
                _Ausstellung in der Kapelle des Universitätsklinikums Essen
                <br/><br/>
                The classical family portrait. Snapshots of seemingly happy days deprived of their scenic background. Traces of facial structures. Focus on the gesture. Hidden joy and hidden depths.`
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/exhibition/a-holy-family/a-holy-family-1.jpg',
                    thumb: './assets/img/exhibition/a-holy-family/a-holy-family-1.jpg',
                    caption: `a holy family #5 communion II (08.2013)<br/>
                    acryl on canvas<br/>
                    50x50cm `
                },
                {
                    grid: 5,
                    divCon: 'left',
                    src: './assets/img/exhibition/a-holy-family/a-holy-family-3.jpg',
                    thumb: './assets/img/exhibition/a-holy-family/a-holy-family-3.jpg',
                    caption: `a holy family #10 unwind (06.2014)<br/>
                    acryl on canvas<br/>
                    50x50cm`
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/exhibition/a-holy-family/a-holy-family-2.jpg',
                    thumb: './assets/img/exhibition/a-holy-family/a-holy-family-2.jpg',
                    caption: `a holy family #1 communion (02.2011) <br/>
                    acryl on canvas<br/>
                    50x50cm`
                },
                {
                    grid: 6,
                    divCon: 'right',
                    src: './assets/img/exhibition/a-holy-family/a-holy-family-4.jpg',
                    thumb: './assets/img/exhibition/a-holy-family/a-holy-family-4.jpg',
                    caption: `a holy family #7 afloat (09.2013) <br/>
                    acryl on canvas <br/>
                    50x50cm `,
                    sold: true
                }
            ]
        },
        linieleerelicht: {
            head: {
                links: [
                    {
                        link: './assets/pdf/exhibition/linie-leere-licht/linie-leere-licht.pdf',
                        target: '_blank',
                        text: '<span class="cBold">_ download:</span> linie leere licht booklet'
                    }
                ],
                line: 'linie leere licht',
                image: './assets/img/exhibition/linie-leere-licht/linie-leere-licht-cover.jpg',
                // tslint:disable-next-line: max-line-length
                text: `<span class="cBold">28. Juni bis 6. September 2015</span>
                <br/>
                _Stichting Culturele Kring, Wieringen - Michaelskerk`
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/exhibition/linie-leere-licht/linie-leere-licht-1.jpg',
                    thumb: './assets/img/exhibition/linie-leere-licht/linie-leere-licht-1.jpg'
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/exhibition/linie-leere-licht/linie-leere-licht-2.jpg',
                    thumb: './assets/img/exhibition/linie-leere-licht/linie-leere-licht-2.jpg'
                },
                {
                    grid: 6,
                    divCon: 'right',
                    src: './assets/img/exhibition/linie-leere-licht/linie-leere-licht-3.jpg',
                    thumb: './assets/img/exhibition/linie-leere-licht/linie-leere-licht-3.jpg'
                }
            ]
        },
        frozenmomentsfamiliar: {
            head: {
                links: [
                    {
                        link: './assets/pdf/exhibition/frozen-moments-familiar/frozen-moments-familiar.pdf',
                        target: '_blank',
                        text: '<span class="cBold">_ download:</span> frozen moments familiar booklet'
                    }
                ],
                line: 'frozen moments familiar',
                image: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-cover.jpg',
                text: `<span class="cBold">15.02. bis 31.05.2015</span>
                        <br/>
                        _Hotel Het Oude Postkantoor, Brummen, Nederland
                        <br/><br/>
                        <span class="cBold">11.11. bis 19.12.2012</span>
                        <br/>
                        _Galerie Augentrost, Cologne, Germany
                        <br/><br/>
                        <span class="cBold">05.02. bis 29.04.2012</span>
                        <br/>
                        _Galerie Huize Hockers, Someren, Nederland`
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-1.jpg',
                    thumb: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-1.jpg'
                },
                {
                    grid: 5,
                    divCon: 'left',
                    src: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-2.jpg',
                    thumb: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-2.jpg'
                },
                {
                    grid: 7,
                    divCon: 'left',
                    src: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-3.jpg',
                    thumb: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-3.jpg'
                },
                {
                    grid: 9,
                    divCon: 'left',
                    src: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-4.jpg',
                    thumb: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-4.jpg'
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-5.jpg',
                    thumb: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-5.jpg'
                },
                {
                    grid: 5,
                    divCon: 'right',
                    src: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-6.jpg',
                    thumb: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-6.jpg'
                },
                {
                    grid: 8,
                    divCon: 'right',
                    src: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-7.jpg',
                    thumb: './assets/img/exhibition/frozen-moments-familiar/frozen-moments-familiar-7.jpg'
                }
            ]
        }
    };

    art = {
        benotafeard: {
            head: {
                line: 'be not afeard',
                column: 'one'
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-1.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-1.jpg',
                    caption: `BeNotAfeard _ Release (10.2018)<br/>
                    Mixed Media & Acryl auf koreanischem und französischem Papier<br/>
                    33,7 x 50,3 cm`
                },
                {
                    grid: 5,
                    divCon: 'left',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-2.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-2.jpg',
                    caption: `BeNotAfeard _ Dream (02.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    50,3 x 33,7 cm`
                },
                {
                    grid: 7,
                    divCon: 'left',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-3.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-3.jpg',
                    caption: `BeNotAfeard _ Frozen (07.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    50,3 x 33,7 cm`,
                    sold:true
                },
                {
                    grid: 9,
                    divCon: 'left',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-4.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-4.jpg',
                    caption: `BeNotAfeard _ Jump I (09.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    33,7 x 50,3 cm`
                },
                {
                    grid: 9,
                    divCon: 'left',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-5.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-5.jpg',
                    caption: `BeNotAfeard _ Catch (01.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    33,7 x 50,3 cm`
                },
                {
                    grid: 2,
                    divCon: 'right',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-6.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-6.jpg',
                    caption: `BeNotAfeard _ Monk (11.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    50,3 x 33,7 cm`
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-7.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-7.jpg',
                    caption: `BeNotAfeard _ Target (02.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    33,7 x 50,3 cm`
                },
                {
                    grid: 6,
                    divCon: 'right',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-8.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-8.jpg',
                    caption: `BeNotAfeard _ Fragile (06.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    50,3 x 33,7 cm`
                },
                {
                    grid: 8,
                    divCon: 'right',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-9.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-9.jpg',
                    caption: `BeNotAfeard _ Out (05.2017)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    50,3 x 33,7 cm`
                },
                {
                    grid: 10,
                    divCon: 'right',
                    src: './assets/img/art-projects/be-not-afeard/be-not-afeard-10.jpg',
                    thumb: './assets/img/art-projects/be-not-afeard/be-not-afeard-10.jpg',
                    caption: `BeNotAfeard _ Jump II (01.2018)<br/>
                    Mixed Media & Acryl auf koreanischem Papier<br/>
                    33,7 x 50,3 cm`
                }
            ]
        },
        aholyfamily: {
            head: {
                line: 'a holy family',
                column: 'one',
                text: `the classical family portrait. snapshots of seemingly happy days deprived of their scenic back­ground. traces of facial structures. focus on the gesture. hidden joy and hidden depths. `
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-communion.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-communion.jpg',
                    caption: 'a holy family #1 communion (02.2011) <br/>acryl on canvas <br/>50x50cm'
                },
                {
                    grid: 5,
                    divCon: 'left',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-seeking.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-seeking.jpg',
                    caption: 'a holy family #3 seeking (08.2011)<br/>acryl on canvas <br/>50x50cm'
                },
                {
                    grid: 7,
                    divCon: 'left',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-communion-II.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-communion-II.jpg',
                    caption: 'a holy family #5 communion II (08.2013) <br/>acryl on canvas <br/>50x50cm'
                },
                {
                    grid: 9,
                    divCon: 'left',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-afloat.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-afloat.jpg',
                    caption: 'a holy family #7 afloat (09.2013)<br/>acryl on canvas <br/>50x50cm',
                    sold: true
                },
                {
                    grid: 11,
                    divCon: 'left',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-wrapped.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-wrapped.jpg',
                    caption: 'a holy family #9 wrapped (01.2014)<br/>acryl on canvas <br/>50x50cm'
                },
                {
                    grid: 13,
                    divCon: 'left',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-catch.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-catch.jpg',
                    caption: 'a holy family #11 catch (02.2015)<br/>acryl on canvas <br/>50x50cm',
                    sold: true
                },
                {
                    grid: 2,
                    divCon: 'right',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-holding.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-holding.jpg',
                    caption: 'a holy family #2 holding (05.2011)<br/>acryl on canvas <br/>50x50cm',
                    sold: true
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-drowning.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-drowning.jpg',
                    caption: 'a holy family #4 drowning (10.2011)<br/>acryl on canvas <br/>50x50cm',
                    sold: true
                },
                {
                    grid: 6,
                    divCon: 'right',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-bottled.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-bottled.jpg',
                    caption: 'a holy family #6 bottled (09.2013)<br/>acryl on canvas <br/>50x50cm'
                },
                {
                    grid: 8,
                    divCon: 'right',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-crowned.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-crowned.jpg',
                    caption: 'a holy family #8 crowned (10.2013)<br/>acryl on canvas <br/>50x50cm'
                },
                {
                    grid: 10,
                    divCon: 'right',
                    src: './assets/img/art-projects/a-holy-family/a-holy-family-unwind.jpg',
                    thumb: './assets/img/art-projects/a-holy-family/a-holy-family-unwind.jpg',
                    caption: 'a holy family #10 unwind (06.2014)<br/>acryl on canvas <br/>50x50cm'
                }
            ]
        },
        virtualnatures: {
            head: {
                line: 'virtual natures',
                column: 'one',
                text: `new technologies = new means of sketching<br/> 
                An array of quick impressions on landscapes … drawn on spot on a mobile surface.`
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/art-projects/virtualnatures/Idoborg-3pm.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Idoborg-3pm.jpg',
                },
                {
                    grid: 5,
                    divCon: 'left',
                    src: './assets/img/art-projects/virtualnatures/Oosterland-8_pm.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Oosterland-8_pm.jpg',
                },
                {
                    grid: 7,
                    divCon: 'left',
                    src: './assets/img/art-projects/virtualnatures/Idoborg-3pm.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Idoborg-3pm.jpg',
                },
                {
                    grid: 9,
                    divCon: 'left',
                    src: './assets/img/art-projects/virtualnatures/Tree-In-Spring.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Tree-In-Spring.jpg',
                },
                {
                    grid: 11,
                    divCon: 'left',
                    src: './assets/img/art-projects/virtualnatures/Wieringen-strand_noon.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Wieringen-strand_noon.jpg',
                },
                {
                    grid: 2,
                    divCon: 'right',
                    src: './assets/img/art-projects/virtualnatures/At-Thomas-Roberts-House.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/At-Thomas-Roberts-House.jpg',
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/art-projects/virtualnatures/Oosterland-3_am.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Oosterland-3_am.jpg',
                }
                ,{
                    grid: 6,
                    divCon: 'right',
                    src: './assets/img/art-projects/virtualnatures/Oosterland-11_am.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Oosterland-11_am.jpg',
                }
                ,{
                    grid: 8,
                    divCon: 'right',
                    src: './assets/img/art-projects/virtualnatures/Shells-On-Window-Sill.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Shells-On-Window-Sill.jpg',
                }
                ,{
                    grid: 10,
                    divCon: 'right',
                    src: './assets/img/art-projects/virtualnatures/Wieringen-22.30_pm.jpg',
                    thumb: './assets/img/art-projects/virtualnatures/Wieringen-22.30_pm.jpg',
                }
            ]
        },
        abandonedspaces: {
            head: {
                line: 'abandoned spaces',
                column: 'one',
                text: `rooms deprived of furniture, their former owners and remnants of the lives that took place there. rooms that are bare. with ghosts still lingering.`
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-I.jpg',
                    thumb: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-I.jpg',
                    caption: 'as #1<br/>03.2014<br/>acryl on canvas <br/>100x120cm',
                    sold:true
                },
                {
                    grid: 5,
                    divCon: 'left',
                    src: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-III.jpg',
                    thumb: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-III.jpg',
                    caption: 'as #3<br/>11.2014<br/>acryl on canvas <br/>100x120cm',
                    sold:true
                },
                {
                    grid: 7,
                    divCon: 'left',
                    src: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-V.jpg',
                    thumb: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-V.jpg',
                    caption: ' <br/> ',
                    sold:true
                },
                {
                    grid: 2,
                    divCon: 'right',
                    src: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-II.jpg',
                    thumb: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-II.jpg',
                    caption: 'as #2<br/>06.2014<br/>acryl on canvas <br/>100x120cm'
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-IV.jpg',
                    thumb: './assets/img/art-projects/abandoned-spaces/abandoned-spaces-IV.jpg',
                    caption: 'as #4<br/>03.2015<br/>acryl on canvas <br/>100x120cm',
                    sold:true
                }
            ]
        },
        childsplay: {
            head: {
                line: 'child\'s play',
                column: 'one',
                text: `spontanity of movement. vibrant and complex, yet wild and on the spur of the moment. regardless of the surroundings.`
            },
            images: [
                {
                    grid: 3,
                    divCon: 'left',
                    src: './assets/img/art-projects/childs-play/childs-play-1.jpg',
                    thumb: './assets/img/art-projects/childs-play/childs-play-1.jpg',
                    caption: 'kinderspiel - heavenhell<br/>acryl on canvas <br/>100x100cm'
                },
                {
                    grid: 5,
                    divCon: 'left',
                    src: './assets/img/art-projects/childs-play/childs-play-3.jpg',
                    thumb: './assets/img/art-projects/childs-play/childs-play-3.jpg'
                },
                {
                    grid: 7,
                    divCon: 'left',
                    src: './assets/img/art-projects/childs-play/childs-play-5.jpg',
                    thumb: './assets/img/art-projects/childs-play/childs-play-5.jpg',
                    caption: 'kinderspiel - jump 1/2/3 (2011/12) trytichon<br/>acryl on canvas <br/>50x100cm / 100x100cm / 50x100cm'
                },
                {
                    grid: 2,
                    divCon: 'right',
                    src: './assets/img/art-projects/childs-play/childs-play-2.jpg',
                    thumb: './assets/img/art-projects/childs-play/childs-play-2.jpg',
                    caption: 'kinderspiel - handstand (08.2010)<br/>acryl on canvas <br/>100x100cm',
                    sold:true
                },
                {
                    grid: 4,
                    divCon: 'right',
                    src: './assets/img/art-projects/childs-play/childs-play-4.jpg',
                    thumb: './assets/img/art-projects/childs-play/childs-play-4.jpg',
                    caption: ' <br/> ',
                    sold:true
                }
            ]
        },
        perception_deception: {
            head: {
                line: 'PERception_DEception',
                column: 'one',
                text: `
                This series bases on snapshots taken of people in exhibitions. And their individual attitude.
                <br/>
                Art in general wishes to be focused on by the viewer. Preferably with the utmost attention.
                <br/>
                But today, an exclusive perception is hard to accomplish as deception is everywhere.
                <br/>
                Often right in our hands. Literarily. 
                <br/>
                <br/>
                Today, one often perceives not with one´s eyes but through a device. 
                <br/>
                Or sometimes not at all. An artistic space, be it an exhibition or performance, tends to be reduced to a background for (digital) interaction. Perception changes into deception. Or the other way around?`,
                imageProperties:{
                    column:1
                }
            },
            images: [
                {
                    grid: 3,
                    video: './assets/video/video.mp4',
                    //caption: `kinderspiel - heavenhell<br/>acryl on canvas <br/>100x100cm`
                },
                {
                    grid: 5,
                    src: './assets/img/art-projects/perception_deception/PERception_DEception-1_threesome-K20-02.2020.jpeg',
                    thumb: './assets/img/art-projects/perception_deception/PERception_DEception-1_threesome-K20-02.2020.jpeg',
                    caption: 'PERception_DEception 1_threesome K20 02.2020<br/>120 x 60 cm<br/>acryl on canvas in artist frame'
                },
                {
                    grid: 7,
                    src: './assets/img/art-projects/perception_deception/PERception_DEception-2_in-view-KM-03.2020.jpeg',
                    thumb: './assets/img/art-projects/perception_deception/PERception_DEception-2_in-view-KM-03.2020.jpeg',
                    caption: 'PERception_DEception 2_in view KM 03.2020<br/>120 x 60 cm<br/>acryl on canvas in artist frame'
                },
                {
                    grid: 9,
                    src: './assets/img/art-projects/perception_deception/PERception_DEception-3_behold-KM-05.2020.jpeg',
                    thumb: './assets/img/art-projects/perception_deception/PERception_DEception-3_behold-KM-05.2020.jpeg',
                    caption: 'PERception_DEception 3_behold KM 05.2020<br/>120 x 60 cm<br/>acryl on canvas in artist frame'
                }
            ]
        }
    };


    constructor(
      public meta: Meta,
      public title: Title,
      private globalVari: GlobalsVariables,
      private router: Router,
      private route: ActivatedRoute,
      private lightbox: Lightbox,
      private location: Location
    ) {
    this.route.params.subscribe( params => {

        this.whichSub = ( this.location.path().indexOf('art-') >= 0) ? 'art' : 'ex';

        this.projectArray = this[this.whichSub][params.project] as Project;
        if ( this.projectArray === undefined) {
            this.router.navigate(['/']);
            return null;
        }

        this.projectArray.images.forEach(element => {
            if (element.caption !== undefined) {
                element.infoText = element.caption + '';
            }
        });

        const site = params.project;
        this.meta.updateTag({ name: 'description', content: globalVari.meta[site].description });
        this.title.setTitle('Chris Wehrmann - ' + globalVari.meta[site].title );

        this.lightboxSource = this[this.whichSub][params.project].images;
    });




    // router.events.subscribe(event => {
    //     if (event instanceof ActivationEnd) {
    //         console.log('Page2', event.snapshot.data );
    //     }
    // });

  }

  open(i: number) {
    const ob = this.lightboxSource[i];
    const light = this.lightboxSource.filter( ele => ele.src !== undefined );
    const index = light.findIndex( (ele) => {
        if (ob.src === ele.src) {
            return true;
        }
        return false;
    });

    this.lightbox.open( light, index, { wrapAround: true, showImageNumberLabel: false });
  }

  checkA(a: any): boolean {
    let re = false;
    if (Array.isArray(a)) {
        re = true;
    }
    return re;
  }

  ngOnInit() {

  }

}
